import script from "./Card.vue?vue&type=script&lang=ts&setup=true"
export * from "./Card.vue?vue&type=script&lang=ts&setup=true"

import "./Card.vue?vue&type=style&index=0&id=4c9a1b85&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9a1b85"]])

export default __exports__